import { CycleRuleDto } from "./../../data/service-proxies/api";
import { Odometer, CargoType } from "../../data/service-proxies/api";
export const DEFAULT_HOS_DATA_SAVED = "DEFAULT_HOS_DATA_SAVED";

export interface ICompanyDefaultHosData {
  companyId?: number | null;
  timeZoneId?: string | null;
  cycleRules?: Array<CycleRuleDto> | null;
  thirtyMinuteBreakException?: boolean | null;
  twentyFourHourCycleReset?: boolean | null;
  dvirWarnings?: boolean | null;
  cargoType?: CargoType | null;
  odometer?: Odometer | null;
}

export const createDefaultHosDataSavedAction = (
  payload: ICompanyDefaultHosData
) => ({
  type: DEFAULT_HOS_DATA_SAVED,
  payload,
});
